var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAboutUs(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "a",
    x: 8.5,
    y: 5,
    width: 9.75,
    height: 7.5,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 0.5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "b"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "b"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "c",
    x: 5.5,
    y: 7.25,
    width: 15.75,
    height: 16.5,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 0.5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "d"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "d"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "e",
    x: 13.375,
    y: 12.875,
    width: 13.125,
    height: 13.125,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 0.5,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "f"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0.161
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "f"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0080ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0030fa"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "h",
    x: 6.5,
    y: 3.5,
    width: 9.75,
    height: 7.5,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "i"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "i"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "k",
    x: 3.5,
    y: 5.75,
    width: 15.75,
    height: 16.5,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "l"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "l"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "m",
    x1: 0.5,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa700"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc31f"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "n",
    x: 11.375,
    y: 11.375,
    width: 13.125,
    height: 13.125,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: -1,
    dy: -1,
    input: "SourceAlpha"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5,
    result: "o"
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#fff"
  }), /*#__PURE__*/React.createElement("feComposite", {
    operator: "in",
    in2: "o"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(14613 15720)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-14730 -15845)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(123 131)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -6, -6)",
    filter: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.188,1.5H9.363a2.067,2.067,0,0,0-3.975,0H4.562A.567.567,0,0,0,4,2.062V3.187A1.319,1.319,0,0,0,5.312,4.5H9.438A1.319,1.319,0,0,0,10.75,3.187V2.062A.567.567,0,0,0,10.188,1.5Z",
    transform: "translate(5 6)",
    fill: "#3d4c76"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -6, -6)",
    filter: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.688,3H10.5v.938A2.061,2.061,0,0,1,8.438,6H4.313A2.061,2.061,0,0,1,2.25,3.938V3H2.062A2.061,2.061,0,0,0,0,5.062v9.375A2.061,2.061,0,0,0,2.062,16.5H7.005a6.553,6.553,0,0,1-.622-2.625H2.813a.563.563,0,0,1,0-1.125h3.63a6.864,6.864,0,0,1,.33-1.313H2.812a.563.563,0,0,1,0-1.125h4.5A6.527,6.527,0,0,1,8.355,9H2.813a.563.563,0,0,1,0-1.125h7.08a6.466,6.466,0,0,1,2.857-.742V5.062A2.061,2.061,0,0,0,10.688,3Z",
    transform: "translate(6 5.25)",
    fill: "#3d4c76"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -6, -6)",
    filter: "url(#e)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.563,10.5a5.063,5.063,0,1,0,5.063,5.063A5.068,5.068,0,0,0,15.563,10.5ZM18,14.557l-2.625,3a.749.749,0,0,1-.539.256h-.025a.749.749,0,0,1-.53-.22l-1.5-1.5a.75.75,0,0,1,1.061-1.061l.933.933,2.1-2.4A.75.75,0,1,1,18,14.557Z",
    transform: "translate(3.38 3.38)",
    fill: "#3d4c76"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -6, -6)",
    filter: "url(#h)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.188,1.5H9.363a2.067,2.067,0,0,0-3.975,0H4.562A.567.567,0,0,0,4,2.062V3.187A1.319,1.319,0,0,0,5.312,4.5H9.438A1.319,1.319,0,0,0,10.75,3.187V2.062A.567.567,0,0,0,10.188,1.5Z",
    transform: "translate(5 6)",
    fill: "url(#g)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -6, -6)",
    filter: "url(#k)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.688,3H10.5v.938A2.061,2.061,0,0,1,8.438,6H4.313A2.061,2.061,0,0,1,2.25,3.938V3H2.062A2.061,2.061,0,0,0,0,5.062v9.375A2.061,2.061,0,0,0,2.062,16.5H7.005a6.553,6.553,0,0,1-.622-2.625H2.813a.563.563,0,0,1,0-1.125h3.63a6.864,6.864,0,0,1,.33-1.313H2.812a.563.563,0,0,1,0-1.125h4.5A6.527,6.527,0,0,1,8.355,9H2.813a.563.563,0,0,1,0-1.125h7.08a6.466,6.466,0,0,1,2.857-.742V5.062A2.061,2.061,0,0,0,10.688,3Z",
    transform: "translate(6 5.25)",
    fill: "url(#g)"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -6, -6)",
    filter: "url(#n)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.563,10.5a5.063,5.063,0,1,0,5.063,5.063A5.068,5.068,0,0,0,15.563,10.5ZM18,14.557l-2.625,3a.749.749,0,0,1-.539.256h-.025a.749.749,0,0,1-.53-.22l-1.5-1.5a.75.75,0,0,1,1.061-1.061l.933.933,2.1-2.4A.75.75,0,1,1,18,14.557Z",
    transform: "translate(3.38 3.38)",
    fill: "url(#m)"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-48 58)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    transform: "translate(-14565 -15778)",
    fill: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAboutUs);
export default __webpack_public_path__ + "static/media/about-us.2145d86e.svg";
export { ForwardRef as ReactComponent };